import React, { useEffect, useMemo, useState } from 'react'
import { useLocalState } from '../../../shared/UseLocalState'
import {
  BookedService,
  ServiceDto,
  ShowDto,
  Starter,
  StarterExmsDto,
  StarterResponse,
  BookedExamResponse,
  StarterDto,
  StarterResponseFromJSON
} from '../../../api'
import { actualShowState } from '../../../state/ActualShow.state'
import { formatDate } from '../../../shared/format-date'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { HorseByRegId } from '../../../shared/HorseByRegId'
import { ExamByStarter, PersonByRegId } from '../../../shared/RiderByRegId'
import InfoIcon from '@mui/icons-material/Info'
import { Dialog } from 'primereact/dialog'
import { authState } from '../../../state/Auth.state'

export const Home = () => {
/* STATE */
const actualShow = useLocalState<ShowDto | undefined>(actualShowState.actualShow$, actualShowState.actualShow$.value)
const starters = useLocalState<Starter[]>(actualShowState.actualShowStarters$, actualShowState.actualShowStarters$.value)

const services = useLocalState<BookedService[]>(
  actualShowState.actualShowBookedServices$,
  actualShowState.actualShowBookedServices$.value
)
const [detail, setDetail] = useState<Starter | null>(null)
const showServices = useLocalState<ServiceDto[]>(actualShowState.actualShowServices$, actualShowState.actualShowServices$.value)

const actualShowBookedServices = useLocalState(actualShowState.actualShowBookedServices$, actualShowState.actualShowBookedServices$.value)

/* DERIVED STATE */

// Services ohne Starter-Zuordnung (z.B. Typ G – Grundgebühr Reiter)
const generalServices = useMemo(
  () => services?.filter((s) => !s?.starterId),
  [services]
)

  /* EFFECTS */
  useEffect(() => {
    // reload data
    authState.user$.next(authState.user$.value)
  }, [])

  /*

                      <Column
                      body={(starter: Starter) => (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                                              >
                        
                          <InfoIcon
                            sx={{ cursor: 'pointer' }}
                            onClick={() => {
                              setDetail(starter)
                            }}
                          />
                        </div>
                      )}
                    />

  */

  /* TEMPLATE */
  return (
    <>
      <Dialog
        visible={!!detail}
        resizable={false}
        draggable={false}
        style={{ maxWidth: '92vw' }}
        header={actualShow?.name}
        onHide={() => setDetail(null)}
        baseZIndex={99999999999999}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div>
            <p>
              <b>Pferd</b>
            </p>
            <p>
              <HorseByRegId regId={detail?.horseRegisterId} />
            </p>
          </div>
          <div>
            <p>
              <b>Reiter</b>
            </p>
            <p>
              <PersonByRegId regId={detail?.riderRegisterId} />
            </p>
          </div>
        </div>
      </Dialog>
      <div>
        <div style={{ marginTop: '1rem' }}>
          {!actualShow && <h3>laden ...</h3>}
          {actualShow && (
            <>
              <div className='card' style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <h3>
                  {actualShow?.name}
                  {actualShow?.announcementLink && (
                    <a
                      href={actualShow.announcementLink}
                      target='_blank'
                      rel='noreferrer'
                      style={{ marginLeft: '0.75rem', fontSize: '0.85rem', fontWeight: 'normal', verticalAlign: 'middle' }}
                    >
                      Ausschreibung
                    </a>
                  )}
                </h3>
                {actualShow?.location && <p>{actualShow?.location}</p>}
                {actualShow?.city && <p>{actualShow?.city}</p>}
                <span style={{ marginTop: '0.25rem' }}></span>
                {actualShow?.startDate && actualShow?.endDate && (
                  <p>
                    Vom {formatDate(actualShow?.startDate)} bis {formatDate(actualShow?.endDate)}
                  </p>
                )}
                {actualShow?.deadlineDate && <p>Stichtag Altersklassen: {formatDate(actualShow?.deadlineDate)}</p>}
                Angemeldet als: {authState.user$.value?.firstName} {authState.user$.value?.lastName}
                              <br></br> Mitgliedsstatus : {authState.user$.value?.member}
                              <br></br> Freizeitreiterstatus : {authState.user$.value?.leisureStatus ? 'Freizeitreiter' : 'Sportreiter'}
              </div>

              {/* Greeting */}
              {(actualShow?.onText1 || actualShow?.onText2 || authState.user$.value?.helloText) && (
                <div style={{ textAlign: 'center', margin: '2rem auto', maxWidth: '600px' }}>
                                  {authState.user$.value?.helloText && <h2 style={{ marginTop: '0.75rem', fontStyle: 'italic' }}>{authState.user$.value.helloText}{actualShow.onText1}</h2>}
                  {actualShow?.onText2 && <p style={{ color: '#555' }}>{actualShow.onText2}</p>}
                </div>
              )}

              <br />

              {/* Allgemeine Services ohne Starter-Zuordnung (z.B. Grundgebühr Reiter) */}
              {generalServices?.length > 0 && (
                <div style={{ marginBottom: '0.75rem' }}>
                  <h3>Ihre gebuchten Services</h3>
                  <DataTable value={generalServices} style={{ width: '100%' }} emptyMessage='Keine Buchungen!'>
                    <Column
                      header='Bezeichnung'
                      body={(service: BookedService) => showServices?.find((s) => s?.id === service?.serviceId)?.name}
                    />
                    <Column
                      header='Menge'
                      headerStyle={{ width: '4rem', textAlign: 'right' }}
                      bodyStyle={{ width: '4rem', textAlign: 'right' }}
                      body={(service: BookedService) => service?.quantity}
                    />
                    <Column
                      header='Preis'
                      headerStyle={{ width: '5rem', textAlign: 'right' }}
                      bodyStyle={{ width: '5rem', textAlign: 'right', whiteSpace: 'nowrap' }}
                      body={(service: BookedService) => service?.totalPrice?.toFixed(2).replace('.', ',') + ' €'}
                    />
                  </DataTable>
                </div>
              )}

              {/* Startnummern mit ihren Services und Prüfungen */}
              {starters?.length < 1 && <h3>Sie haben noch keine Startnummer gebucht!</h3>}
              {starters?.length > 0 && (
                <>
                  <h3>Ihre gebuchten Startnummern</h3>
                  {starters?.map((starter) => {
                    const starterServices = services?.filter((s) => s?.starterId === starter?.id)
                    return (
                      <div key={starter?.id} style={{ marginBottom: '1rem' }}>
                        <p style={{ fontWeight: 'bold', margin: '0.5rem 0 0.25rem 0' }}>
                          Nr. {starter?.startNo} – <HorseByRegId regId={starter?.horseRegisterId} /> / <PersonByRegId regId={starter?.riderRegisterId} />
                        </p>
                        {starterServices?.length > 0 && (
                          <DataTable value={starterServices} style={{ width: '100%' }} emptyMessage='Keine Services!'>
                            <Column
                              header='Service'
                              body={(service: BookedService) => showServices?.find((s) => s?.id === service?.serviceId)?.name}
                            />
                            <Column
                              header='Menge'
                              headerStyle={{ width: '4rem', textAlign: 'right' }}
                              bodyStyle={{ width: '4rem', textAlign: 'right' }}
                              body={(service: BookedService) => service?.quantity}
                            />
                            <Column
                              header='Preis'
                              headerStyle={{ width: '5rem', textAlign: 'right' }}
                              bodyStyle={{ width: '5rem', textAlign: 'right', whiteSpace: 'nowrap' }}
                              body={(service: BookedService) => service?.totalPrice?.toFixed(2).replace('.', ',') + ' €'}
                            />
                          </DataTable>
                        )}
                        {(starter as StarterResponse)?.bookedExams && (
                          <ExamByStarter bookedExams={(starter as StarterResponse).bookedExams!} />
                        )}
                      </div>
                    )
                  })}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}
